import * as C from '../common/constants';
import React from 'react';
import clsx from 'clsx';
import bg from '../assets/img/album_main_bg_reduced.png';
import repeatBg from '../assets/img/bg_repeat.jpg';
import topBg from '../assets/img/bg_top.jpg';
import {
  StyleRules,
  Theme,
  createStyles,
  makeStyles,
} from '@material-ui/core/styles';

const useStyles = makeStyles(
  (theme: Theme): StyleRules =>
    createStyles({
      backgroundStyle: {
        position: 'absolute',
        width: `${C.MAX_WIDTH}px`,
        height: '100%',
        display: 'flex',
        flexWrap: 'wrap',
      },
      // bgContainerImg: {
      //   position: 'relative',
      //   width: '50%',
      //   // height: '50%',
      // },
      // bgImg: {
      //   width: '100%',
      //   // height: '101%',
      // },
      // tl: {},
      // tr: {
      //   transform: 'scaleX(-1)',
      // },
      // bl: {
      //   transform: 'scaleY(-1)',
      // },
      // br: {
      //   transform: 'scale(-1, -1)',
      // },
      bgTopStyle: {
        position: 'absolute',
        left: 0,
        top: 0,
        width: `${C.MAX_WIDTH}px`,
        height: '100px',
        backgroundImage: `url("${topBg}")`,
      },
      bgRepeatStyle: {
        position: 'relative',
        width: `${C.MAX_WIDTH}px`,
        height: 'auto',
        backgroundImage: `url("${repeatBg}")`,
        backgroundRepeat: 'repeat-y',
        backgroundSize: '100% auto',
      },
    })
);

const AlbumBackground = () => {
  const classes = useStyles();
  return (
    <div className={classes.backgroundStyle}>
      {/* <div className={classes.bgContainerImg}>
        <img className={clsx(classes.bgImg, classes.tl)} src={bg} alt="" />
      </div>
      <div className={classes.bgContainerImg}>
        <img className={clsx(classes.bgImg, classes.tr)} src={bg} alt="" />
      </div> */}
      <div className={classes.bgRepeatStyle} />
      <div className={classes.bgTopStyle} />
      {/* <div className={classes.bgContainerImg}>
        <img className={clsx(classes.bgImg, classes.bl)} src={bg} alt="" />
      </div>
      <div className={classes.bgContainerImg}>
        <img className={clsx(classes.bgImg, classes.br)} src={bg} alt="" />
      </div> */}
    </div>
  );
};

export default AlbumBackground;
